<p-toast />
<div class="wrapper">
  <div class="mxn-portrait-overlay">
    <div class="mxn-portrait-mode">
      <img src="./assets/mobile-portrait-mode-icon.svg" alt="" />
      <h3>Please Rotate Your Device</h3>
      <p>
        For the best experience, this website is optimized for portrait mode.
        Kindly rotate your device to continue browsing.
      </p>
    </div>
  </div>
  <div class="mxn-header">
    <div class="flex justify-content-between align-items-center flex-wrap">
      <div class="flex justify-content-between lg:gap-4 w-full lg:w-full">
        <p-multiSelect
          [options]="panels"
          [(ngModel)]="selectedPanels"
          (onChange)="onPanelChange($event)"
          optionLabel="label"
          optionValue="value"
          scrollHeight="400px"
          [placeholder]="panelSelectionPlaceholder"
          styleClass="hidden lg:flex"
        />

        <div
          class="w-full mb-3 lg:mb-0"
          [ngClass]="{
            'flex': isMobile$ | async,
            'flex-row': isMobile$ | async,
          }"
        >
          <div class="mxn-detailClose-brn">
            <div *ngIf="selectedNotification" class="mxn-detailClose-btn">
              <em
                class="pi pi-arrow-left"
                (click)="selectedNotification = null"
                (keydown)="selectedNotification = null"
              ></em>
            </div>
          </div>
          <div class="flex flex-row justify-content-between w-full">
            <p-inputGroup class="mxn-search-group">
              <button type="button" class="pButton px-2 py-2 bg-white">
                <img src="assets/search.svg" alt="search" />
              </button>
              <input
                type="text"
                class="pInputText"
                [(ngModel)]="search"
                (change)="onSearchChange()"
                placeholder="Search in patient and notification details"
              />
              <button
                *ngIf="search.length > 0"
                type="button"
                class="pButton px-2 py-2 bg-white clearSearchBtn"
                (click)="onClearSearch()"
              >
                <img src="assets/delete-btn.svg" alt="clear search" />
              </button>
            </p-inputGroup>
            <div class="flex gap-3 align-items-center">
              <div class="">
                <p-button
                  type="button"
                  class="max-setting-btn"
                  (onClick)="openSettingsDrawer()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1050_1970)">
                      <path
                        d="M7.9316 11.5972C7.64027 11.5877 7.44705 11.4936 7.30064 11.3049C6.99338 10.9085 6.5895 10.6869 6.08752 10.6749C5.53425 10.6615 5.099 10.898 4.77033 11.3417C4.55818 11.6281 4.23249 11.7207 3.89834 11.5947C3.74745 11.5379 3.59805 11.4767 3.45214 11.409C2.99996 11.1978 2.58264 10.9304 2.19669 10.6147C1.92628 10.3935 1.85307 10.0639 1.9965 9.71827C2.27189 9.05593 2.10606 8.35526 1.56324 7.8981C1.3496 7.71832 1.10309 7.60378 0.826707 7.56494C0.325725 7.49522 0.110093 7.27262 0.0478437 6.77313C-0.0293455 6.15561 -0.0124137 5.54308 0.0986391 4.93154C0.164374 4.569 0.41138 4.33096 0.78388 4.28465C1.7983 4.15865 2.40834 3.16764 2.06373 2.20452C1.9223 1.80961 2.01343 1.51131 2.34958 1.25485C2.81321 0.901271 3.31718 0.6209 3.86198 0.413734C4.2066 0.282761 4.5049 0.351484 4.74493 0.633848C5.06016 1.00436 5.45407 1.21451 5.94211 1.22198C6.45006 1.22945 6.8644 1.02228 7.18809 0.63335C7.36339 0.422698 7.58748 0.321107 7.8569 0.358954C7.99335 0.377878 8.12731 0.434152 8.25629 0.487437C8.7991 0.712531 9.2966 1.01382 9.74878 1.38831C10.0202 1.61291 10.1133 1.90822 9.9933 2.23241C9.62578 3.2274 10.2856 4.20298 11.2129 4.34142C11.5759 4.3957 11.7726 4.61681 11.8428 4.98084C11.9738 5.66011 11.9614 6.33888 11.8319 7.01615C11.7711 7.33287 11.5187 7.56494 11.1955 7.61225C10.1805 7.75965 9.58942 8.75515 9.94748 9.71329C10.0869 10.0868 10.0097 10.3786 9.70097 10.6311C9.23933 11.0081 8.73237 11.3089 8.1801 11.5325C8.08598 11.5703 7.98239 11.5843 7.9321 11.5972H7.9316ZM7.91566 10.7924C8.34394 10.6162 8.74881 10.3711 9.12529 10.0763C9.18804 10.027 9.20298 9.98818 9.17559 9.91199C9.03316 9.51708 8.9988 9.10872 9.09193 8.70186C9.32598 7.68197 9.96093 7.05898 10.9873 6.83637C11.0246 6.8284 11.0774 6.78259 11.0824 6.74823C11.1591 6.22882 11.1666 5.70891 11.066 5.1915C11.0595 5.15763 11.0092 5.11431 10.9724 5.10634C9.59191 4.80306 8.79313 3.44154 9.20547 2.085C9.22539 2.01927 9.2214 1.98391 9.16563 1.93909C8.77072 1.62585 8.33946 1.37586 7.87234 1.18712C7.80461 1.15973 7.77075 1.17716 7.72593 1.22696C6.79069 2.27922 5.14183 2.28072 4.21158 1.22945C4.16178 1.17318 4.12493 1.16222 4.05471 1.19061C3.64237 1.35793 3.25891 1.57456 2.89886 1.8365C2.82018 1.89377 2.81271 1.94158 2.84159 2.02823C3.1374 2.92014 2.85255 3.91912 2.13594 4.52717C1.80676 4.80655 1.43177 4.98732 1.00499 5.05654C0.919832 5.07048 0.876009 5.09488 0.859575 5.19697C0.780892 5.69148 0.777904 6.18599 0.820233 6.68299C0.826209 6.75221 0.853101 6.78209 0.924314 6.79354C2.40037 7.03009 3.27784 8.53653 2.75395 9.93689C2.72307 10.0201 2.73851 10.0599 2.80474 10.1102C3.17525 10.3931 3.57514 10.6226 4.00391 10.8059C4.10501 10.8487 4.15829 10.8383 4.22901 10.7516C5.01335 9.78799 6.43463 9.6102 7.42912 10.3542C7.59993 10.4822 7.74784 10.6406 7.91516 10.7924H7.91566Z"
                        fill=""
                      />
                      <path
                        d="M5.97246 3.61087C7.27372 3.60888 8.35187 4.67808 8.35486 5.97386C8.35785 7.304 7.29513 8.38316 5.98142 8.38415C4.64879 8.38515 3.58059 7.32044 3.57959 5.9893C3.57859 4.67957 4.65177 3.61287 5.97196 3.61087H5.97246ZM4.37539 5.99776C4.37489 6.87025 5.08802 7.58537 5.962 7.58886C6.83498 7.59234 7.55757 6.87772 7.55957 6.00922C7.56156 5.12577 6.84942 4.40617 5.97295 4.40567C5.091 4.40567 4.37638 5.11781 4.37539 5.99776Z"
                        fill=""
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1050_1970">
                        <rect
                          width="11.9354"
                          height="11.3"
                          fill=""
                          transform="translate(0 0.350006)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </p-button>
              </div>
              <div class="mxn-export-notify mxn-overlay">
                <div class="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="12"
                    viewBox="0 0 10 12"
                    fill="none"
                  >
                    <path
                      d="M0.335449 11.6667H9.66878V10.3333H0.335449V11.6667ZM9.66878 4.33334H7.00212V0.333344H3.00212V4.33334H0.335449L5.00212 9.00001L9.66878 4.33334Z"
                      fill=""
                    />
                  </svg>
                  <div class="mxn-overlay-ddm">
                    <div class="mxn-overlay-items">
                      <ul>
                        <li>
                          <a
                            href="#"
                            (click)="handleDownloadNotification('ADT')"
                            >Export ADT Notifications</a
                          >
                        </li>
                        <li>
                          <a
                            href="#"
                            (click)="handleDownloadNotification('COVID')"
                            >Export COVID Notifications</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <button
                  type="button"
                  pButton
                  class="mxn-filters-btn"
                  (click)="openFilters()"
                >
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.8574 1.62623C13.372 1.62623 15.8866 1.62623 18.4019 1.62623C18.8211 1.62623 19.0865 1.81339 19.1815 2.17531C19.2483 2.43029 19.1434 2.64027 18.9976 2.84047C17.8677 4.3912 16.7384 5.94259 15.6091 7.49397C14.9205 8.43954 14.2358 9.38837 13.5412 10.3294C13.2811 10.6822 13.1594 11.0643 13.1607 11.498C13.1668 13.1093 13.1634 14.7214 13.1627 16.3328C13.1627 16.769 13.0364 16.9477 12.6198 17.1036C11.6203 17.4772 10.6214 17.8509 9.62118 18.2219C9.15784 18.3934 8.73261 18.2239 8.60624 17.8124C8.57148 17.7002 8.56412 17.577 8.56412 17.459C8.56145 15.4889 8.55543 13.5195 8.56747 11.5495C8.57081 11.0663 8.43174 10.6554 8.14558 10.2642C6.33368 7.79003 4.53181 5.30873 2.72659 2.82939C2.44377 2.44007 2.47653 2.0325 2.81284 1.77361C2.96929 1.65297 3.15249 1.62558 3.34638 1.62558C5.30471 1.62688 7.26303 1.62623 9.22135 1.62623C9.76626 1.62623 10.3118 1.62623 10.8567 1.62623H10.8574Z"
                    />
                  </svg>

                  Filters
                  <span
                    *ngIf="this.appliedFilterCount !== 0"
                    class="mxn-notify-bubble"
                    >{{ this.appliedFilterCount }}</span
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex pt-4">
    <div class="mxn-left-col">
      <div class="mxn-lhs-header">
        <ul class="flex list-none gap-2 tab-items flex-1 justify-content-around">
          <li
            (click)="onTabChangeHandler('all')"
            (keydown)="onTabChangeHandler('all')"
          >
            <a [ngClass]="{ active: selectedTab === 'all' }"
              >All
              <span
                class="mxn-notify-bubble all"
                >{{notificationCountByStatus?.['all'] || 0 | notificationFilterCounter}}</span
              ></a
            >
          </li>
          <li
            (click)="onTabChangeHandler('not-started')"
            (keydown)="onTabChangeHandler('not-started')"
          >
            <a [ngClass]="{ active: selectedTab === 'not-started' }"
              >Not Started
              <span
                class="mxn-notify-bubble red"
                >{{notificationCountByStatus?.['not-started'] || 0 | notificationFilterCounter}}</span
              ></a
            >
          </li>
          <li
            (click)="onTabChangeHandler('in-progress')"
            (keydown)="onTabChangeHandler('in-progress')"
          >
            <a [ngClass]="{ active: selectedTab === 'in-progress' }"
              >In Progress
              <span
                class="mxn-notify-bubble blue"
                >{{notificationCountByStatus?.['in-progress'] || 0 | notificationFilterCounter}}</span
              ></a
            >
          </li>
          <li
            (click)="onTabChangeHandler('completed')"
            (keydown)="onTabChangeHandler('completed')"
          >
            <a [ngClass]="{ active: selectedTab === 'completed' }"
              >Completed
              <span
                class="mxn-notify-bubble green"
                >{{notificationCountByStatus?.['completed'] || 0 | notificationFilterCounter}}</span
              ></a
            >
          </li>
        </ul>
        <div class="mxn-notify-sorting mxn-overlay">
          <p-button styleClass="mxn-sorting-btn" />
          <div class="mxn-overlay-ddm" id="op" #op>
            <div class="mxn-overlay-items w-9rem">
              <div class="mxn-sorting-heading">Sort By</div>
              <ul>
                <li
                  [ngClass]="{
                    'li-active': currentSort === 'unread'
                  }"
                  (click)="onSortHandler('unread')"
                  (keydown)="onSortHandler('unread')"
                >
                  <span class="mxn-sortby-icon" [ngClass]="{ class: true }">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.17045 3.75C4.3296 3.75 3.52318 4.08403 2.9286 4.6786C2.33403 5.27318 2 6.0796 2 6.92045V16.0795C2 16.9204 2.33403 17.7268 2.9286 18.3214C3.52318 18.916 4.3296 19.25 5.17045 19.25H18.5568C19.3977 19.25 20.2041 18.916 20.7987 18.3214C21.3932 17.7268 21.7273 16.9204 21.7273 16.0795V6.92045C21.7273 6.0796 21.3932 5.27318 20.7987 4.6786C20.2041 4.08403 19.3977 3.75 18.5568 3.75H5.17045ZM20.3182 7.55666L11.8636 12.1087L3.40909 7.55666V6.92045C3.40909 6.45331 3.59466 6.0053 3.92498 5.67498C4.2553 5.34466 4.70331 5.15909 5.17045 5.15909H18.5568C19.024 5.15909 19.472 5.34466 19.8023 5.67498C20.1326 6.0053 20.3182 6.45331 20.3182 6.92045V7.55666ZM3.40909 9.15668L11.5297 13.5298C11.6323 13.585 11.7471 13.614 11.8636 13.614C11.9802 13.614 12.095 13.585 12.1976 13.5298L20.3182 9.15668V16.0795C20.3182 16.5467 20.1326 16.9947 19.8023 17.325C19.472 17.6553 19.024 17.8409 18.5568 17.8409H5.17045C4.70331 17.8409 4.2553 17.6553 3.92498 17.325C3.59466 16.9947 3.40909 16.5467 3.40909 16.0795V9.15668Z"
                        fill=""
                      />
                      <circle cx="20" cy="6" r="4" fill="" />
                    </svg>
                  </span>
                  Unread
                </li>
                <li
                  [ngClass]="{
                    'li-active': currentSort === 'comments'
                  }"
                  (click)="onSortHandler('comments')"
                  (keydown)="onSortHandler('comments')"
                >
                  <span class="mxn-sortby-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.97848 10.4343C4.05884 10.515 4.12039 10.6125 4.15874 10.7197C4.19709 10.827 4.21129 10.9414 4.20032 11.0548C4.1458 11.5794 4.04252 12.0978 3.89182 12.6033C4.59649 12.4535 5.28093 12.2208 5.93086 11.9101C6.10072 11.8241 6.29633 11.8037 6.48026 11.8529C7.00801 11.9936 7.55196 12.0644 8.09814 12.0634C11.1918 12.0634 13.5177 9.89096 13.5177 7.41864C13.5177 4.94633 11.1918 2.77384 8.09814 2.77384C5.0045 2.77384 2.67863 4.94633 2.67863 7.41951C2.68478 7.98308 2.80286 8.53981 3.026 9.05735C3.24914 9.5749 3.57291 10.0429 3.97848 10.4343ZM3.59632 13.4569C3.41319 13.4933 3.22919 13.5268 3.04432 13.5574C3.00892 13.5623 2.97287 13.5576 2.93987 13.5439C2.90687 13.5302 2.87813 13.5079 2.85659 13.4794C2.83505 13.4509 2.8215 13.4172 2.81733 13.3817C2.81317 13.3462 2.81853 13.3102 2.83288 13.2775C2.90163 13.1152 2.9646 12.9508 3.02179 12.7844V12.7766C3.2248 12.1958 3.36087 11.5937 3.42734 10.982C2.9505 10.5184 2.57038 9.96485 2.30902 9.35334C2.04767 8.74182 1.91027 8.08452 1.90479 7.41951C1.90479 4.42639 4.6778 2 8.09814 2C11.5185 2 14.2915 4.42639 14.2915 7.41951C14.2915 10.4126 11.5185 12.839 8.09814 12.839C7.4838 12.8402 6.87197 12.7607 6.27835 12.6025C5.42515 13.0063 4.52165 13.294 3.59199 13.4578L3.59632 13.4569Z"
                        fill=""
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.00195 5.48428C5.00195 5.38155 5.04276 5.28302 5.11541 5.21038C5.18805 5.13773 5.28658 5.09692 5.38931 5.09692H10.808C10.9074 5.10163 11.0012 5.14445 11.0699 5.2165C11.1387 5.28854 11.177 5.38428 11.177 5.48385C11.177 5.58341 11.1387 5.67915 11.0699 5.75119C11.0012 5.82324 10.9074 5.86606 10.808 5.87077H5.38931C5.28673 5.87077 5.18833 5.83008 5.11571 5.75762C5.04309 5.68516 5.00218 5.58686 5.00195 5.48428ZM5.00195 7.41932C5.00195 7.31659 5.04276 7.21807 5.11541 7.14542C5.18805 7.07278 5.28658 7.03197 5.38931 7.03197H10.808C10.9074 7.03668 11.0012 7.0795 11.0699 7.15154C11.1387 7.22359 11.177 7.31933 11.177 7.41889C11.177 7.51845 11.1387 7.61419 11.0699 7.68624C11.0012 7.75828 10.9074 7.80111 10.808 7.80581H5.38931C5.28673 7.80581 5.18833 7.76512 5.11571 7.69267C5.04309 7.62021 5.00218 7.52191 5.00195 7.41932ZM5.00195 9.35437C5.00195 9.25164 5.04276 9.15311 5.11541 9.08047C5.18805 9.00782 5.28658 8.96701 5.38931 8.96701H8.48555C8.585 8.97172 8.67882 9.01454 8.74754 9.08659C8.81626 9.15863 8.85459 9.25437 8.85459 9.35394C8.85459 9.4535 8.81626 9.54924 8.74754 9.62128C8.67882 9.69333 8.585 9.73615 8.48555 9.74086H5.38931C5.28688 9.74086 5.18861 9.70029 5.11602 9.62802C5.04342 9.55575 5.00241 9.4568 5.00195 9.35437Z"
                        fill=""
                      />
                    </svg>
                  </span>
                  Comments
                </li>
                <li
                  [ngClass]="{
                    'li-active': currentSort === 'Newest'
                  }"
                  (click)="onSortHandler('Newest')"
                  (keydown)="onSortHandler('Newest')"
                >
                  <span class="mxn-sortby-icon">
                    <em class="pi pi-arrow-up"></em>
                  </span>
                  Newest
                </li>
                <li
                  [ngClass]="{
                    'li-active': currentSort === 'Oldest'
                  }"
                  (click)="onSortHandler('Oldest')"
                  (keydown)="onSortHandler('Oldest')"
                >
                  <span class="mxn-sortby-icon">
                    <em class="pi pi-arrow-down"></em>
                  </span>
                  Oldest
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mxn-filtered-results">
        <div>
          <label>Results:</label> {{ notificationsinList || 0 }} out of
          {{ totalNotifications }}
        </div>
        <button
          class="mxn-refresh-btn"
          type="button"
          *ngIf="isNotificationListUpdated"
          (click)="handleListRefresh()"
        >
          <p-image src="assets/ion_refresh.svg" alt="refresh" />
        </button>
      </div>

      <mxn-notification-list
        [notifications]="notifications"
        (onNotificationSelect)="onNotificationSelect($event)"
        [selectedNotifications] = selectedNotifications
        [loading]="isLoadingNotifications"
        [notificationsinList]="notificationsinList"
        [totalNotifications]="totalNotifications"
        (getNotificationCall)="getNotificationsCall()"
        (scrollToComments)="scrollToComments()"
        (updateOpenedNotification)="updateOpenedNotification($event)"
        (handleSelectedNotifications)="handleSelectedNotifications($event)"
        [currentPageSettings]="currentPageSettings"
        [notificationCountByStatus]="notificationCountByStatus"
        (notificationRemovedUpdateStats)="notificationRemovedUpdateStats($event)"
        [selectAllNotificationsForMultiSelect]="selectAllNotificationsForMultiSelect"
        
      ></mxn-notification-list>

      <div>
        <div class="flex-auto">
          <mxn-pagination
            [totalItems]="totalNotifications"
            [rowsPerPage]="rowsPerPage"
            [currentPage]="currentPage"
            (pageChange)="onPageChange($event)"
            [rowsOptions]="[
              { label: '10', value: 10 },
              { label: '20', value: 20 },
              { label: '30', value: 30 }
            ]"
            [showExtraDetails]="false"
          ></mxn-pagination>
        </div>
      </div>
    </div>
    <div
      class="mxn-right-col flex-1 p-2 border-1 border-round border-gray-300"
      [ngClass]="{ 'mob-view': (isMobile$ | async) && selectedNotification }"
    >
      <mxn-notification-detail
        [totalNumberOfNotifications] ="totalNotifications"
        [notification]="selectedNotification"
        (scrollToComments)="scrollToComments()"
        (statusBadgeChangeEvent)="handleStatusChange($event)"
        (addCommentInNotification)="addCommentInNotification($event)"
        (deleteCommentInNotification)="deleteCommentInNotification($event)"
        [checkboxSelectedNotifications]="selectedNotifications"
        (clearSelectedNotifications)="clearSelectedNotifications($event)"
        (selectAllNotificationsOnCurrentPage)="selectAllNotificationsOnCurrentPage()"
        [currentPageSettings]="currentPageSettings"
        (statusBadgeChangeEventForMultiple)="handleStatusChangeForMultiple($event)"
        (selectAllNotificationsInboxPages)="selectAllNotificationsInboxPages()"
        (markReadUnreadChangeEventForMultiple)="handleMarkReadUnreadChangeEventForMultiple($event)"
        (removedChangeEventForMultiple)="handleRemovedChangeEventForMultiple($event)"
        (removedChangeEventForAll)="handleRemovedChangeEventForAllNotifications()"
        (statusBadgeChangeEventForAll)="handleStatusChangeForAll($event)"
        (markReadUnreadChangeEventForAll)="handleMarkReadUnreadChangeEventForAll($event)"
        [selectAllNotificationsInbox]="selectAllNotificationsForMultiSelect"
        [showDefaultPage]="showDefaultPage"
      ></mxn-notification-detail>
    </div>
  </div>
</div>
<p-sidebar
  [(visible)]="sidebarVisible2"
  position="right"
  styleClass="p-sidebar-md"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Email Settings</span>
  </ng-template>
  <form #alertFrequencyForm="ngForm">
    <div *ngIf="!isLoadingSettings; else loadingBlock">
    <div class="max-usersetting-prf">
      <div class="flex justify-content-between align-items-center w-full">
        <div>Subscribe to All Email Notifications</div>
        <div>
          <label class="switch-label">
            <div class="switch">
              <input
                id="allEmailSubscribed"
                type="checkbox"
                name="allEmailSubscribed"
                [(ngModel)]="allEmailSubscribed"
                (change)="onChangeEmailSettings($event)"
              />
              <span class="slider round"></span>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="max-usersetting-prf">
      <div class="max-usersetting-prf2">
        <div class="flex justify-content-between align-items-center w-full">
          <div class="headerWrapper">
            <div>Subscribe to Custom Email Notifications</div>
          </div>
          <div>
            <label class="switch-label">
              <div class="switch">
                <input
                  id="customEmailSubscribed"
                  type="checkbox"
                  name="customEmailSubscribed"
                  [(ngModel)]="customEmailSubscribed"
                  (change)="onChangeEmailSettings($event)"
                />
                <span class="slider round"></span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="customEmailSubscribed">
        <div class="subtitle">
          To use this option, at least one saved filter must be created.
          <br />
          Select the filter(s) below for email notifications.
        </div>
        <app-check-box
          [checkboxes]="customEmailOptions"
          class="optionsWrapper"
          (checkboxChange)="onChangeCustomEmailSettings($event)"
        >
        </app-check-box>
      </div>
    </div>
    <div class="max-usersetting-prf p-0">
      <div class="max-usersetting-prf2 p-3">
        <div class="flex justify-content-between align-items-center w-full">
          <div class="headerWrapper">
            <div>Alert Frequency</div>
            <p class="alertFrequency-subtitle">Select the frequency you’d like to receive email alerts.</p>
          </div>
          <div>
            
          </div>
        </div>
      </div>
      <div class="alertFrequency-wrapper p-3">
        <div class="subtitle">
          
        </div>
        
        <p-radioButton
        [value]=fifteenMinutesFrequency
        name="fifteenMinuteFrequencyField"
        inputId="alertFrequency1"
        [(ngModel)]="selectedFrequency"
        (click)="resetTimeValidation()"
        [disabled]="!allEmailSubscribed && !customEmailSubscribed"
        /> 
        <label for="alertFrequency1" class="ml-2">Default: <span><em>Every 15 minutes</em></span></label>

        <div class="py-3">
          <label class="">Every Hour</label>
          <div class="flex align-items-center mt-2 gap-3">
            <div class="w-13rem">
              <p-radioButton
              [value]=everyHourTwentyFourHourFrequency
              name="withinTwentyFourHourFrequencyField"
              inputId="alertFrequency2"
              [(ngModel)]="selectedFrequency"
              (click)="resetTimeValidation()"
              [disabled]="!allEmailSubscribed && !customEmailSubscribed"
              /> 
              <label for="alertFrequency2" class="ml-2"> <span>Every Hour <em>(Within 24h)</em></span></label>
            </div>
            <div>
              <p-radioButton
              [value]=everyHourOfficeHourFrequency
              name="duringOfficeHourFrequencyField"
              inputId="alertFrequency3"
              [(ngModel)]="selectedFrequency"
              (click)="resetTimeValidation()"
              [disabled]="!allEmailSubscribed && !customEmailSubscribed"
              /> 
              <label for="alertFrequency3" class="ml-2"><span>During Office Hours <em>(8am-5pm PT)</em></span></label>
            </div>
          </div>
        </div>
        
        <div class="py-3">
          <label class="mb-2">Up to 3 Times a Day</label>
          <div class="flex justify-content-between align-items-center mt-2">
            <div class="w-12rem">
              <p-radioButton
              [value]=onceADayFrequency
              name="onceADayFrequencyField"
              inputId="alertFrequency4"
              [(ngModel)]="selectedFrequency"
              (click)="resetTimeValidation()"
              [disabled]="!allEmailSubscribed && !customEmailSubscribed"
              /> 
              <label for="alertFrequency4" class="ml-2"> <span>Once a Day</span></label>
            </div>
            <div class="w-12rem">
              <p-radioButton
              [value]=twiceADayFrequency
              name="twiceADayFrequencyField"
              inputId="alertFrequency5"
              [(ngModel)]="selectedFrequency"
              (click)="resetTimeValidation()"
              [disabled]="!allEmailSubscribed && !customEmailSubscribed"
              /> 
              <label for="alertFrequency5" class="ml-2"><span>Twice a Day</span></label>
            </div>
            <div class="w-12rem">
              <p-radioButton
              [value]=threeTimesADayFrequency
              name="threeTimesADayFrequencyField"
              inputId="alertFrequency6"
              [(ngModel)]="selectedFrequency"
              (click)="resetTimeValidation()"
              [disabled]="!allEmailSubscribed && !customEmailSubscribed"
              /> 
              <label for="alertFrequency6" class="ml-2"><span>3 Times a Day</span></label>
            </div>
          </div>
        </div>  

        <div class="flex justify-content-between">
          <div class="w-12rem pl-4">
            <p-calendar 
            [(ngModel)]="onceADayTimeInput"
            name="onceADay"
            #onceADayInput="ngModel"
            [timeOnly]="true"
            [hourFormat]="'12'"
            placeholder="HH : MM : AM"
            [required]="selectedFrequency == onceADayFrequency"
            [disabled]="selectedFrequency != onceADayFrequency"
            (onSelect)="processTimeInput($event, 'onceADay')"
            (input)="setFrequencyInput($event, 'onceADay')"
            (keydown)="validateKeyPressed($event)"
            (onBlur)="verifyEmptyInput('onceADay')"
            [ngClass]="errorOnceADayInput ? 'ng-invalid ng-dirty' : ''">
            </p-calendar>
          </div>
          <div class="w-12rem flex flex-column gap-2 pl-4">
            <p-calendar 
            [(ngModel)]="twiceADayInputOne" 
            name="twiceADayInputOne" 
            #twiceADayOne="ngModel"
            [timeOnly]="true"
            [hourFormat]="'12'"
            placeholder="HH : MM : AM"
            [required]="selectedFrequency==twiceADayFrequency"
            [disabled]="selectedFrequency!=twiceADayFrequency"
            (onSelect)="processTimeInput($event, 'twiceADayInputOne')"
            (input)="setFrequencyInput($event, 'twiceADayInputOne')"
            (keydown)="validateKeyPressed($event)"
            (onBlur)="verifyEmptyInput('twiceADayInputOne')"
            [ngClass]="errorTwiceADayInputOne? 'ng-invalid ng-dirty' : ''">
            </p-calendar>
            <p-calendar
            [(ngModel)]="twiceADayInputTwo"
            name="twiceADayInputTwo"
            #twiceADayTwo="ngModel"
            [timeOnly]="true"
            [hourFormat]="'12'"
            placeholder="HH : MM : AM"
            [required]="selectedFrequency==twiceADayFrequency"
            [disabled]="selectedFrequency!=twiceADayFrequency"
            (onSelect)="processTimeInput($event, 'twiceADayInputTwo')"
            (input)="setFrequencyInput($event, 'twiceADayInputTwo')"
            (keydown)="validateKeyPressed($event)"
            (onBlur)="verifyEmptyInput('twiceADayInputTwo')"
            [ngClass]="errorTwiceADayInputTwo ? 'ng-invalid ng-dirty' : ''">
            </p-calendar>
          </div>
          <div class="w-12rem flex flex-column gap-2 pl-4">
            <p-calendar type="time"
            [(ngModel)]="threeTimesADayInputOne"
            name="threeTimesADayInputOne"
            #threeTimesADayOne="ngModel"
            [timeOnly]="true"
            [hourFormat]="'12'"
            placeholder="HH : MM : AM"
            [required]="threeTimesADayFrequency"
            [disabled]="selectedFrequency!=threeTimesADayFrequency"
            (onSelect)="processTimeInput($event, 'threeTimesADayInputOne')"
            (input)="setFrequencyInput($event, 'threeTimesADayInputOne')"
            (keydown)="validateKeyPressed($event)"
            (onBlur)="verifyEmptyInput('threeTimesADayInputOne')"
            [ngClass]="errorThreeTimesADayInputOne ? 'ng-invalid ng-dirty' : ''">
            </p-calendar>
            <p-calendar type="time"
            [(ngModel)]="threeTimesADayInputTwo"
            name="threeTimesADayInputTwo"
            #threeTimesADayTwo="ngModel"
            [timeOnly]="true"
            [hourFormat]="'12'"
            placeholder="HH : MM : AM"
            [required]="threeTimesADayFrequency"
            [disabled]="selectedFrequency!=threeTimesADayFrequency"
            (onSelect)="processTimeInput($event, 'threeTimesADayInputTwo')"
            (input)="setFrequencyInput($event, 'threeTimesADayInputTwo')"
            (keydown)="validateKeyPressed($event)"
            (onBlur)="verifyEmptyInput('threeTimesADayInputTwo')"
            [ngClass]="errorThreeTimesADayInputTwo ? 'ng-invalid ng-dirty' : ''">
            </p-calendar>
            <p-calendar type="time"
            [(ngModel)]="threeTimesADayInputThree"
            name="threeTimesADayInputThree"
            #threeTimesADayThree="ngModel"
            [timeOnly]="true"
            [hourFormat]="'12'"
            placeholder="HH : MM : AM"
            [required]="threeTimesADayFrequency"
            [disabled]="selectedFrequency!=threeTimesADayFrequency"
            (onSelect)="processTimeInput($event, 'threeTimesADayInputThree')"
            (input)="setFrequencyInput($event, 'threeTimesADayInputThree')"
            (keydown)="validateKeyPressed($event)"
            (onBlur)="verifyEmptyInput('threeTimesADayInputThree')"
            [ngClass]="errorThreeTimesADayInputThree ? 'ng-invalid ng-dirty' : ''">
            </p-calendar>
          </div>
        </div>

        <div class="mt-2">
          <div *ngIf="onceADayInput.invalid && onceADayInput.touched && selectedFrequency === 'onceADay'">
            <small style="color: red;"><strong>Incomplete Field:</strong> Time is required when 'Once a Day' frequency is selected</small>
          </div>
          <div *ngIf="(twiceADayOne.invalid || twiceADayTwo.invalid) && twiceADayOne.touched && selectedFrequency === 'twiceADay'">
            <small style="color: red;"><strong>Incomplete Field:</strong> Time is required when 'Twice a Day' frequency is selected</small>
          </div>
          
          <div *ngIf="(threeTimesADayOne.invalid || threeTimesADayTwo.invalid || threeTimesADayThree.invalid) && threeTimesADayOne.touched && selectedFrequency === 'threeTimesADay'">
            <small style="color: red;"><strong>Incomplete Field:</strong> Time is required when 'Three Times a Day' frequency is selected</small>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
<ng-template #loadingBlock>
    <div class="loader">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-template>
      <div class="flex gap-2">
      <div class="col-6 pl-0">
        <p-button
          label="Cancel"
          styleClass="max-cancel-btn"
          (click)="onCloseEmailSettings()"
          (keydown)="onCloseEmailSettings()"
        />
      </div>
      <div class="col-6 pr-0">
        <div class="flex max-fltrBtn-wrapper">
          <p-button
            label="Save"
            (click)="onSaveEmailSettings()"
            class="w-full flex-1"
            styleClass="max-FltApply-btn"
            [disabled]="isLoadingSettings"
            (keydown)="onSaveEmailSettings()"
          />
        </div>
      </div>
    </div>
</p-sidebar>
<app-filters
  [visible]="filtersVisible"
  [defaultFilterId]="defaultFilterId"
  [appliedFilter]="appliedFilter"
  [panels]="panels"
  (close)="closeFilters()"
  (applied)="handleAppliedFilters($event)"
  (applyFilters)="handleApplyFilters($event)"
></app-filters>
